const DEFAULT_ERROR_MESSAGE = "Something went wrong. Please try again.";

const extractFromPayload = (payload: unknown): string | null => {
  if (!payload) {
    return null;
  }

  if (typeof payload === "string") {
    return payload;
  }

  if (Array.isArray(payload)) {
    const messages = payload
      .map((item) => extractFromPayload(item))
      .filter((message): message is string => Boolean(message));

    return messages.length ? messages.join(", ") : null;
  }

  if (typeof payload === "object") {
    const record = payload as Record<string, unknown>;
    const directMessage =
      extractFromPayload(record.detail) ||
      extractFromPayload(record.message) ||
      extractFromPayload(record.msg) ||
      extractFromPayload(record.error);

    if (directMessage) {
      return directMessage;
    }

    try {
      return JSON.stringify(payload);
    } catch {
      return null;
    }
  }

  return String(payload);
};

export const getErrorMessage = (
  error: unknown,
  fallback: string = DEFAULT_ERROR_MESSAGE
): string => {
  const err = error as {
    response?: { data?: unknown };
    data?: unknown;
    detail?: unknown;
    message?: unknown;
  };

  return (
    extractFromPayload(err?.response?.data) ||
    extractFromPayload(err?.data) ||
    extractFromPayload(err?.detail) ||
    extractFromPayload(err?.message) ||
    extractFromPayload(error) ||
    fallback
  );
};
